import { useFirestore } from 'react-redux-firebase';
import collections from '../../constants/FirestoreCollections';
import { ITemplate } from '../../Interfaces/ITemplate';

export default function useTemplates() {
  const firestore = useFirestore();

  const getTemplates = (): Promise<ITemplate[]> => {
    return firestore
      .collection(collections.templates)
      .get()
      .then((snapshot) => {
        const templates: ITemplate[] = [];
        snapshot.forEach((e: any) => {
          templates.push({ ...e.data(), id: e.id });
        });
        return templates;
      });
  };

  return { getTemplates };
}
